angular.module('manufacturing')
    .component('manufacturingOrderLinkedOrders', {
        bindings: {
            item: '<',
            canManage: '<'
        },
        templateUrl: 'app/manufacturing/linked-orders.html',
        controller: function (ManufacturingOrderService) {
            this.ManufacturingOrderService = ManufacturingOrderService

            this.$onChanges = () => {
                const linkedOrders = this.item && angular.isArray(this.item.linkedOrders) ? this.item.linkedOrders : []
                this.linkedOrders = linkedOrders.map(order => angular.extend({}, order, {
                    nodes: (order.nodes || []).filter(node => node && node.name).slice().sort((first, second) => first.name.localeCompare(second.name))
                }))
                this.summaries = this.buildSummaries()
            }

            this.hasDifferentEntity = (relatedEntity, currentEntity) => {
                if (!relatedEntity) return false
                if (!currentEntity) return true
                return relatedEntity.id !== currentEntity.id
            }

            this.hasDifferentClient = order => this.hasDifferentEntity(order && order.client, this.item && this.item.client)
            this.hasDifferentProduct = order => this.hasDifferentEntity(order && order.product, this.item && this.item.product)
            this.hasDifferentDeliveryTime = order => this.toTimestamp(order && order.deliveryTime) !== this.toTimestamp(this.item && this.item.deliveryTime)
            this.toTimestamp = value => value == null ? null : new Date(value).getTime()

            this.buildSummaries = () => {
                if (!this.item || this.linkedOrders.length === 0) return []
                return [this.item].concat(this.linkedOrders).reduce((summaries, order) => {
                    const unit = order.product && order.product.defaultUnit
                    const key = unit && unit.id != null ? unit.id : 'without-unit'
                    let summary = summaries.find(item => item.key === key)
                    if (!summary) {
                        summary = {key: key, unit: unit, quantityOrdered: 0, quantityCompleted: 0}
                        summaries.push(summary)
                    }
                    summary.quantityOrdered += Number(order.quantityOrdered || 0)
                    summary.quantityCompleted += Number(order.quantityCompleted || 0)
                    return summaries
                }, [])
            }

            this.link = () => ManufacturingOrderService.link(this.item.id)
            this.unlink = order => ManufacturingOrderService.unlink(this.item.id, order.id)
            this.open = order => ManufacturingOrderService.open(order.id)
        }
    })
